@let cols = columns();
<table tabindex="0">
  <thead>
    <tr>
      @for (column of cols; track column) {
        <th>{{ labels()[column] }}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of data(); track $index) {
      <tr>
        @for (column of cols; track column) {
          <td>{{ row[column] }}</td>
        }
      </tr>
    }
  </tbody>
</table>
